import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';
import ErrorPage from 'components/pages/Error';
import resetViewport from 'utils/resetViewport';
import userAgent from 'utils/userAgent';
import { useLocation } from 'react-router-dom';
const SentryWrapper = ({ children }) => {
    const location = useLocation();
    useEffect(() => {
        if (!location)
            return;
        window.scrollTo(0, 0);
        gtag('config', 'UA-105776977-2', { page_path: location.pathname });
        userAgent();
        resetViewport();
    }, [location]);
    return React.createElement(Sentry.ErrorBoundary, { fallback: React.createElement(ErrorPage, null) }, children);
};
export default SentryWrapper;
